// Server address
global.SERVER_ADDRESS = 'https://webdemo.afribonemali.net/suivi_consommation/backend/public/api';
// Local address
//global.SERVER_ADDRESS = 'http://localhost:8000/api';